const formatDate = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours %= 12;
  hours = hours || 12;
  const formatedTime =
    minutes === 0
      ? `${hours} ${ampm}`
      : `${hours}:${minutes < 10 ? `0${minutes}` : minutes} ${ampm}`;
  return formatedTime;
};

export default formatDate;
